module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1bb",
    attrs: {
      "id": "d7e266435"
    }
  }, [_c('span', [_vm._v("corn salad")])]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "d7e266935"
    }
  }, [_c('span', [_vm._v("(field lettuce, lamb’s tongue, mâche, feldsalat)")])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e267435"
    }
  }, [_c('span', [_vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ALERIANELLA LOCUSTA")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e267935"
    }
  }, [_c('span', [_vm._v("I used to find corn salad distressingly bland, but I’ve come around. Its soft taste and texture make a good foil for more pungent winter greens. This is a venerable and popular European market plant. It’s easy to grow—almost too easy at times, as its tiny seeds can spread its range rapidly if you let it self-sow. I’ve used it as a winter ground cover; it out-competes many of the weeds that gain footholds in milder winters and is easy to dig under in the spring. Unbruised plants will keep about a week under refrigeration.")])]), _vm._v(" "), _c('p', {
    staticClass: "h1b",
    attrs: {
      "id": "d7e271135"
    }
  }, [_c('span', [_vm._v("dandelions")])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e271635"
    }
  }, [_c('span', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAXACUM OFFICINALE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e272135"
    }
  }, [_c('span', [_vm._v("In earliest spring, dandelion fanciers dot their yards with upended flower pots to blanch the young growth of their favorite weed. Commercial seed, available from some catalogs, produces a slightly less bitter green, but I doubt the difference is worth the expense. Seeds marketed as Italian dandelion are actually a form of chicory, a different genus. Dandelion greens are used primarily in salads. They are high in vitamin C among other nutrients, though not usually eaten in such quantities as to make that a major consideration. They don’t keep well.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e275535"
    }
  }, [_c('span', [_vm._v("Although the roots have the stronger effect, the leaves are also a diuretic (note the French common name, "), _c('i', [_vm._v("pissenlit")]), _vm._v("), commonly used in herbal tonics. Once the plant flowers, the leaves will be too bitter to eat; however, the sunny flowers can be used to make a traditional dessert wine.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1c3baac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Morg_9781550924589_epub_c16_r1.vue
// module id = 105
// module chunks = 0